import { useCallback, useState } from "react";
import { checkIfEnum } from "../utils/check-if-enum";

export const useEnum = <T>(initialValue: T, enumType: any): [T, (newValue: T) => void, boolean] => {
  const [value, setValue] = useState<T>(initialValue);
  const [valid, setValid] = useState(checkIfEnum<T>(initialValue, enumType));

  const onChange = useCallback(
    (newValue: T) => {
      setValue(newValue);
      setValid(checkIfEnum<T>(newValue, enumType));
    },
    [setValue, setValid, enumType],
  );

  return [value, onChange, valid];
};
